import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "./NavBar.css";
import LOGO from "./DTG-Testing-Logo.png";

export default function NavBar() {
  const { isAuth, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  if (!isAuth) return null;

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = "/login";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <header className="dtg-nav" role="banner">
      <div className="dtg-nav__inner">
        <div className="dtg-logo">
          <img src={LOGO} alt="DTG Testing" className="DTG_Testing-logo" />
          <p className="projectName">DTG Remote Zoo</p>
        </div>

        <nav className="dtg-links" aria-label="Primary">
          <Tab to="/rcu" label="RCU" />
          <Tab to="/video" label="VIDEO" />
          <Tab to="/system-information" label="SYSTEM INFORMATION" />
        </nav>

        <button
          className="dtg-logout dtg-logout--desktop"
          onClick={handleLogout}
        >
          Logout
        </button>

        <button
          className="dtg-menu"
          aria-label="Toggle menu"
          aria-expanded={open}
          aria-controls="dtg-mobile-menu"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="dtg-menu__bar" />
          <span className="dtg-menu__bar" />
          <span className="dtg-menu__bar" />
        </button>
      </div>

      <div
        id="dtg-mobile-menu"
        className={`dtg-mobile ${open ? "dtg-mobile--open" : ""}`}
        role="region"
        aria-label="Mobile navigation"
      >
        <nav className="dtg-mobile__links" aria-label="Primary mobile">
          <Tab to="/rcu" label="RCU" />
          <Tab to="/video" label="VIDEO" />
          <Tab to="/system-information" label="SYSTEM INFORMATION" />
        </nav>
        <button
          className="dtg-logout dtg-logout--mobile"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </header>
  );
}

function Tab({ to, label }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `dtg-link${isActive ? " dtg-link--active" : ""}`
      }
      end={to === "/"}
    >
      {label}
    </NavLink>
  );
}
